import OneSignal from "react-onesignal";
import { useEffect, useRef } from "react";
import { useAppContext } from "../services/context";
import { loginToOneSignal, logoutOnesignal } from "../services/onesignal";
import { getUserData } from "../services/dataManager";
import { updatePlayerId } from "../services/axios/apiManager";
import { onesignal_app_id } from "../services/axios/eps";

const InitializeOneSignal = () => {
  const { state, setState } = useAppContext();
  const { onesignalInitialized, user } = state;
  const lastUserIdRef = useRef(undefined);

  useEffect(() => {
    if (!onesignalInitialized) {
      OneSignal.init({ appId: onesignal_app_id }).then(() => {
        setState((prev) => ({ ...prev, onesignalInitialized: true }));
        OneSignal.Slidedown.promptPush();
      });
    }
  }, [onesignalInitialized, setState]);

  useEffect(() => {
    if (!user) {
      const syncUserData = async () => {
        const storedUser = await getUserData();
        if (storedUser?.id) {
          setState((prev) => ({ ...prev, user: storedUser }));
        }
      };
      syncUserData();
    }
  }, [user, setState]);

  useEffect(() => {
    if (!onesignalInitialized) return;

    const syncOneSignalUser = async () => {
      const currentUserId = user?.id || null;

      if (currentUserId === lastUserIdRef.current) return;

      if (currentUserId) {
        console.log("OneSignal integration: Logging in user");
        await loginToOneSignal(currentUserId);
        const playerId = OneSignal.User.onesignalId;
        if (playerId) {
          await updatePlayerId({ player_id: playerId });
        }
      } else if (lastUserIdRef.current !== undefined) {
        console.log("OneSignal integration: Logging out user");
        await logoutOnesignal();
      }

      lastUserIdRef.current = currentUserId;
    };

    syncOneSignalUser();
  }, [onesignalInitialized, user?.id]);
  return null;
};

export default InitializeOneSignal;
